<template>
<div class="chapter">
<div class="inner_page">
<section class="level1" data-number="1" epub:type="part" id="part-one">
<h1 data-number="1" epub:type="part">Part One</h1>
<section class="level2" data-number="1.1" id="shadows-of-destiny">
<h2 data-number="1.1">Shadows of Destiny</h2>
<section class="level3" data-number="1.1.1" id="section">
<h3 data-number="1.1.1">1939–1940</h3>
</section>
</section>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?102bd90e